/*
 * Rapid Relief buy box — Figma 3797-6449.
 *
 * Every price this file shows was formatted by Liquid and parked on the radio that stands for
 * that choice (data-price, data-compare, data-save, data-unit), so the script never does money
 * maths and never rounds: it copies strings. What it does own is the state the cart reads —
 * the hidden quantity (pack jars x stepper) and the selling plan — plus the labels that have to
 * follow the selection: the add-to-cart price, the sticky bar and the price under the title.
 */
(function () {
  function init(box) {
    if (box.dataset.rrReady === 'true') return;
    box.dataset.rrReady = 'true';

    var sectionId = box.dataset.sectionId;
    var form = box.closest('form');
    var quantityInput = box.querySelector('[data-rr-quantity]');
    var planInput = box.querySelector('[data-rr-selling-plan]');
    var panels = box.querySelectorAll('[data-rr-plan]');
    var stepper = document.getElementById('Quantity-' + sectionId);

    /** The radio that decides what the cart gets: the visible panel's, else the pack card's. */
    function activeChoice() {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].hidden) continue;
        var picked = panels[i].querySelector('.rr-plan__input:checked');
        if (picked) return picked;
      }
      return box.querySelector('.rr-pack__input:checked');
    }

    function currentPack() {
      var pack = box.querySelector('.rr-pack__input:checked');
      return pack ? pack.value : null;
    }

    function showPanelFor(pack) {
      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i].dataset.pack !== pack;
      }
    }

    /* The price under the title is rendered for the subscribe allocation; from here on it
       follows the buy box, so only the one-time state stays and we write into it. Mobile has
       its own copy above the gallery; the section only mirrors texts into it, not which state
       shows, so both copies are driven here. */
    function updateTitlePrice(choice) {
      document.querySelectorAll('[data-cro-price-widget], [data-cro-price-widget-mobile]').forEach(function (widget) {
        widget.querySelectorAll('[data-cro-price-state]').forEach(function (state) {
          state.hidden = state.dataset.croPriceState !== 'onetime';
        });
        var state = widget.querySelector('[data-cro-price-state="onetime"]');
        if (!state) return;

        var priceEl = state.querySelector('[data-cro-ot-price]');
        if (priceEl) priceEl.textContent = choice.dataset.price || '';

        var unitEl = state.querySelector('[data-rr-top-unit]');
        if (!unitEl && priceEl) {
          unitEl = document.createElement('span');
          unitEl.className = 'rr-top-unit';
          unitEl.setAttribute('data-rr-top-unit', '');
          priceEl.insertAdjacentElement('afterend', unitEl);
        }
        if (unitEl) {
          unitEl.textContent = choice.dataset.unit || '';
          unitEl.hidden = !choice.dataset.unit;
        }

        var compareEl = state.querySelector('[data-cro-ot-compare]');
        if (compareEl) {
          compareEl.textContent = choice.dataset.compare || '';
          compareEl.hidden = !choice.dataset.compare;
        }

        var badgeEl = state.querySelector('.cro-title-price__save-badge');
        if (badgeEl) {
          badgeEl.textContent = choice.dataset.save || '';
          badgeEl.hidden = !choice.dataset.save;
        }
      });
    }

    function update() {
      var choice = activeChoice();
      if (!choice) return;

      var jars = parseInt(choice.dataset.qty, 10) || 1;
      var packs = stepper ? parseInt(stepper.value, 10) || 1 : 1;
      if (quantityInput) quantityInput.value = String(jars * packs);

      if (planInput) {
        var planId = choice.dataset.planId || '';
        planInput.value = planId;
        if (planId) {
          planInput.setAttribute('name', 'selling_plan');
        } else {
          planInput.removeAttribute('name');
        }
      }

      var label = ' • ' + (choice.dataset.price || '');
      if (form) {
        var priceEl = form.querySelector('[data-product-form-submit-price]');
        if (priceEl) priceEl.textContent = label;
      }
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = label;

      updateTitlePrice(choice);
    }

    box.addEventListener('change', function (event) {
      if (!event.target.matches('.rr-pack__input, .rr-plan__input')) return;
      if (event.target.matches('.rr-pack__input')) showPanelFor(currentPack());
      update();
    });

    if (stepper) {
      stepper.addEventListener('change', update);
      stepper.addEventListener('input', update);
      var stepperForm = document.getElementById('Quantity-Form-' + sectionId);
      if (stepperForm) {
        stepperForm.addEventListener('click', function (event) {
          if (event.target.closest('.quantity__button')) setTimeout(update, 0);
        });
      }
    }

    showPanelFor(currentPack());
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-rr-buy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
